export default () => {
  return useRuntimeConfig().public.selfServiceCheckoutEnabled && !useWorkspaceStore().distributor;
};
